import React from "react";
import { AlertTriangle, X } from "lucide-react";
import LinkedActivityPanel from "./floor/LinkedActivityPanel";

export default function DisableLeagueModal({ open, leagueName, activity, busy, onCancel, onForceDisable }) {
  if (!open) return null;

  return (
    <div className="alg-modal-backdrop" onClick={onCancel} role="presentation">
      <div className="alg-modal alg-disable-modal" onClick={(e) => e.stopPropagation()} role="dialog" aria-modal="true">
        <div className="alg-modal-head">
          <strong className="inline-flex items-center gap-2">
            <AlertTriangle size={14} aria-hidden />
            Cannot disable safely
          </strong>
          <button type="button" className="am-chrome-btn am-chrome-btn-icon" onClick={onCancel}>
            <X size={14} />
          </button>
        </div>
        <div className="alg-modal-body">
          <p className="alg-disable-copy">
            <strong>{leagueName}</strong> still has linked activity across its fixtures. Disabling would
            stop sync jobs but leave pending bets, P2P, predictions, and markets unsettled.
          </p>
          <LinkedActivityPanel activity={activity} compact />
        </div>
        <div className="alg-modal-foot">
          <button type="button" className="alg-btn" onClick={onCancel} disabled={busy}>
            Keep enabled
          </button>
          <button type="button" className="alg-btn alg-btn-danger" onClick={onForceDisable} disabled={busy}>
            {busy ? "Disabling…" : "Disable anyway"}
          </button>
        </div>
      </div>
    </div>
  );
}
